
function getParameters()
{
  const prmstr = window.location.search.substr(1);
  return prmstr !== null && prmstr !== '' ? transformToAssocArray(prmstr) : {
  };
}

function transformToAssocArray(prmstr)
{
  const params = {
  };
  const prmarr = prmstr.split('&');
  for(let i = 0; i < prmarr.length; i++)
  {
    const tmparr = prmarr[i].split('=');
    params[tmparr[0]] = tmparr[1];
  }
  return params;
}

function objToGetParameters(obj)
{
  let res = '';
  let prefix = '?';
  for(const key in obj)
  {
    if(obj[key] !== '')
    {
      res += prefix + key + '=' + obj[key];
      prefix = '&';
    }
  }
  return res;
}

function ajaxCallWithPromise(url)
{

  return new Promise(function(resolve, reject)
  {
    const objXMLHttpRequest = new XMLHttpRequest();

    objXMLHttpRequest.onreadystatechange = function()
    {
      if(objXMLHttpRequest.readyState === 4)
      {
        if(objXMLHttpRequest.status === 200)
        {
          resolve(objXMLHttpRequest.responseText);
        }
        else
        {
          reject('Error Code: ' + objXMLHttpRequest.status + ' Error Message: ' + objXMLHttpRequest.statusText);
        }
      }
    };
    objXMLHttpRequest.open('GET', url);
    objXMLHttpRequest.send();
  });

}

export { getParameters, ajaxCallWithPromise, objToGetParameters };
